import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

export const deleteWeatherFolder = (folderId: number) => {
  return axios.delete(`/api/folders/weather/${folderId}`);
};

type UseDeleteWeatherFolderOptions = {
  config?: MutationConfig<typeof deleteWeatherFolder>;
};

export const useDeleteWeatherFolder = ({
  config,
}: UseDeleteWeatherFolderOptions) => {
  return useMutation({
    onError: (_, __, context: any) => {
      if (context?.previousWeatherFolders) {
        queryClient.setQueryData(
          ['weatherFolders'],
          context.previousWeatherFolders
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['weatherFolders']);
      queryClient.invalidateQueries(['weatherWalls']);
    },
    ...config,
    mutationFn: deleteWeatherFolder,
  });
};
